import { Component, OnInit, inject } from '@angular/core';

import { KnBrDraftOrderDetailHeaderComponent } from 'src/feature-libs/kn-br-cart/saved-carts/components/kn-br-draft-order/kn-br-draft-order-detail/kn-br-draft-order-detail-header/kn-br-draft-order-detail-header.component';
import { Location } from '@angular/common';
import { ChangeDetectorRef, ComponentRef, OnDestroy, ViewContainerRef } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CmsService,
  ContentSlotData,
  Currency,
  CurrencyService,
  CxDatePipe,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  WindowRef,
} from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import * as _ from 'lodash';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { filter, map, skip, startWith, switchMap } from 'rxjs/operators';
import { KnBrCartContextService } from 'src/feature-libs/kn-br-cart/base/core/facade/kn-br-cart-context.service';

import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root';
import { LAUNCH_CALLER } from '@spartacus/storefront';
//import { UserAccountService } from '@spartacus/user/account/core';
import { KnBrDraftOrdersService } from 'src/feature-libs/kn-br-cart/saved-carts/core/facade/kn-br-draft-orders.service';
import { KnBrDraftOrder } from 'src/feature-libs/kn-br-cart/saved-carts/root/models/kn-br-draft-order.model';
import { UserAccountService } from 'src/feature-libs/kn-br-user/kn-br-account/core/facade/user-account.service';
import { KnBrCommonService } from 'src/services/kn-br-common.service';
import { KnBrDateHelper } from 'src/shared/kn-br-date.helper';
import { KnBrDateFormatService } from 'src/shared/kn-br-date-format.service';
import { RemoveLeadingZerosPipe } from 'src/shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';
import { KnBrPricingVisibilityService } from 'src/services/kn-br-pricing-visibility.service';
import { BLOCKED_DIST_CHAIN_STATUSES } from '../../models/atg-draft-order.constants';

@Component({
  selector: 'atg-draft-order-detail-header',
  templateUrl: './atg-draft-order-detail-header.component.html',
  styleUrls: ['./atg-draft-order-detail-header.component.scss'],
  providers: [CxDatePipe, KnBrDateHelper, RemoveLeadingZerosPipe],
  standalone: false,
})
export class AtgDraftOrderDetailHeaderComponent
  extends KnBrDraftOrderDetailHeaderComponent
  implements OnInit, OnDestroy
{
  declare draftOrder: KnBrDraftOrder;
  hidePricing$ = inject(KnBrPricingVisibilityService).hidePricing$;
  hasUnsavedItemChanges$: Observable<boolean> | undefined;
  hasNoOrderPlacementRole$: Observable<boolean> | undefined;
  hideOrderActions$: Observable<boolean> | undefined;
  isCartOwnerCurrentUser$: Observable<boolean> | undefined;
  hasDisabledProductTypeEntries = false;
  hasBlockedDistChainEntries = false;
  hasZeroNetPriceEntry = false;
  lineItemErrorMessages: string[] = [];
  isCustomerPOValid = true;
  isECCAvailable= true;
  integrationMessage: string | '' = '';
  initialLoad: boolean = true;
  // True while the active cart's own reload (fired by KnBrDraftOrdersService after ANY
  // successful PATCH -- Update Cart, or the "Update Net Price" link -- via
  // multiCartService.loadCart()) has itself failed, e.g. a backend
  // JaloObjectNoLongerValidError. The PATCH can succeed while this follow-up reload
  // fails, so this has to be tracked separately from initialLoad/hasZeroNetPriceEntry:
  // Checkout must not open just because the PATCH went through when we never actually
  // got confirmed fresh cart data back.
  hasCartLoadError: boolean = false;
  showPromoCode: boolean = false;
  showQuoteNumber: boolean = false;
  showSalesDeal: boolean = false;
  showStoreNumber: boolean = false;
  sapMessageErrors: { [key: string]: string } = {};
  hasSapErrors: boolean = false;
  isPartialReorder: boolean = false;
  costCenters: any[] = [];
  isPromoCodeToastDismissed: boolean = false;
  isQuoteToastDismissed: boolean = false;
  pageTitle$: Observable<string>;
  constructor(
    protected currentUserService: UserAccountService,
    protected activeCartService: ActiveCartFacade,
    protected fb: UntypedFormBuilder,
    protected ngbCalendar: NgbCalendar,
    protected cmsService: CmsService,
    protected knBrCommonService: KnBrCommonService,
    protected cdr: ChangeDetectorRef,
    protected knBrDraftOrderService: KnBrDraftOrdersService,
    protected location: Location,
    protected routingService: RoutingService,
    protected knBrDateHelper: KnBrDateHelper,
    protected multiCartService: MultiCartFacade,
    protected knBrCartContextService: KnBrCartContextService,
    protected modalService: NgbModal,
    protected currencyService: CurrencyService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected removeLeadingZerosPipe: RemoveLeadingZerosPipe,
    protected globalMessageService: GlobalMessageService,
    protected knBrDateFormatService: KnBrDateFormatService,
    protected winRef: WindowRef
  ) {
    super(
      currentUserService,
      activeCartService,
      fb,
      ngbCalendar,
      cmsService,
      knBrCommonService,
      cdr,
      knBrDraftOrderService,
      location,
      routingService,
      knBrDateHelper,
      multiCartService,
      knBrCartContextService,
      modalService,
      currencyService,
      launchDialogService,
      vcr,
      removeLeadingZerosPipe,
      globalMessageService,
      knBrDateFormatService
    );
    this.pageTitle$ = this.cmsService.getCurrentPage().pipe(map((page) => page?.title ?? ''));
  }

  // The backend's requestedDeliveryDate echo has proven unreliable (a re-formatted
  // round-trip can silently swap day/month), so once the user picks a date for this
  // cart, that choice becomes the standing source of truth in sessionStorage -- it is
  // never re-derived from a string, never re-parsed, and never auto-cleared. Every
  // patchForm call re-applies it verbatim, so it survives any number of format
  // toggles, cart re-emissions, or full page refreshes unchanged. It's only replaced
  // when the user submits a genuinely new value, and stops applying once the cart
  // itself changes (different code).
  private rddOverrideKey(): string {
    return `kn-br-rdd-override-${this.draftOrder?.code || ''}`;
  }

  private setRddOverride(value: NgbDateStruct): void {
    this.winRef.sessionStorage?.setItem(this.rddOverrideKey(), JSON.stringify(value));
  }

  private getRddOverride(): NgbDateStruct | null {
    const raw = this.winRef.sessionStorage?.getItem(this.rddOverrideKey());
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setFieldVisibility();
    // Clear line item errors on component load
    this.knBrDraftOrderService.setLineItemErrors([]);
    this.isCustomerPOValid = true;
    this.integrationMessage = '';
    // Get the observable from service
    this.hasUnsavedItemChanges$ = this.knBrDraftOrderService.getHasUnsavedItemChanges();
    this.hasNoOrderPlacementRole$ = this.currentUserService.get().pipe(
      map((user: any) => Array.isArray(user?.roles) && user.roles.includes('atg-no-orderplcement-group')),
      startWith(false)
    );
    this.hideOrderActions$ = combineLatest([this.hidePricing$, this.hasNoOrderPlacementRole$]).pipe(
      map(([hidePricing, hasNoOrderPlacementRole]) => hidePricing || hasNoOrderPlacementRole)
    );
    // Hide checkout when the logged-in user is the same as the cart owner (e.g. a sales rep
    // viewing their own cart rather than a customer's), since checkout should only be placed
    // on behalf of a customer.
    this.isCartOwnerCurrentUser$ = combineLatest([
      this.currentUserService.get() as Observable<any>,
      this.activeCartService.getActive() as Observable<any>,
    ]).pipe(
      map(([user, cart]) => !!user?.uid && !!cart?.user?.uid && user.uid !== cart.user.uid),
      startWith(false)
    );
    // Subscribe to draft order changes and check for disabled product types
    this.subscription.add(
      this.activeCartService.getActive().subscribe(() => {
        this.checkForDisabledProductTypeEntries();
        this.checkForBlockedDistChainEntries();
        this.checkForZeroNetPriceEntries();
        this.updatePOValidationStatus();
        this.checkisECCAvailablele();
        this.checkPartialReorder();
        this.validateSapMessages();
        this.knBrDraftOrderService.setLineItemErrors([]);
        this.loadCostCenters();
        this.cdr.detectChanges();
      })
    );

    // The "Click here to update Net Price" link on a line item (atg-draft-order-item)
    // recalculates pricing through the same triggerItemUpdate()/PATCH path as this
    // header's own "Update Cart" button, but it can't reach this.initialLoad directly
    // since it lives in a different component. Listen for that same shared trigger here
    // too, so Checkout becomes enabled once mandatory fields are filled after using
    // either path -- not just after clicking "Update Cart" itself.
    this.subscription.add(
      this.knBrDraftOrderService.getItemUpdateTrigger$()
        .pipe(skip(1))
        .subscribe(() => {
          this.initialLoad = false;
          this.cdr.detectChanges();
        })
    );

    // Track the active cart's own load/reload outcome (loadCart() dispatched after
    // every successful PATCH) so a failure there -- the PATCH itself can succeed while
    // this follow-up reload fails, e.g. a backend JaloObjectNoLongerValidError -- keeps
    // Checkout disabled instead of opening on stale/unconfirmed cart data.
    this.subscription.add(
      this.activeCartService.getActiveCartId().pipe(
        switchMap((cartId) => (cartId ? this.multiCartService.getCartEntity(cartId) : of(undefined)))
      ).subscribe((entity: any) => {
        this.hasCartLoadError = !!entity?.error;
        this.cdr.detectChanges();
      })
    );

    // The "Click Here to update Net Price" link (atg-draft-order-item, a different
    // component) can't reach this header's own reactive form, so it just asks here to run
    // updateCart() on its behalf -- guaranteeing the exact same full-form payload "Update
    // Cart" itself sends. A minimal { entryList }-only PATCH was enough to trip a backend
    // PO-duplicate false positive, since the backend re-validates purchaseOrderNumber
    // uniqueness against whatever actually gets sent and treats a missing field as blank.
    this.subscription.add(
      this.knBrDraftOrderService.getNetPriceUpdateRequested$()
        .pipe(skip(1))
        .subscribe(() => {
          this.updateCart();
        })
    );
  }

  private loadCostCenters(): void {
    if (this.draftOrder?.orderType !== 'ZFD') {
      this.costCenters = [];
      return;
    }

    this.knBrCommonService.getCostCenters().subscribe({
      next: (centers: any[]) => {
        this.costCenters = centers ?? [];
        this.cdr.detectChanges();
        if (this.draftOrder?.orderReasonCode) {
          this.draftOrderEditForm?.patchValue({ orderReasonCode: this.draftOrder.orderReasonCode });
        }
      },
      error: () => {
        this.costCenters = [];
        this.cdr.detectChanges();
      },
    });
  }

  checkPartialReorder(): void {
    this.isPartialReorder = this.draftOrder?.isPartialReorder === true;
  }

  checkForDisabledProductTypeEntries(): void {
    if (this.draftOrder && this.draftOrder.entries && this.draftOrder.entries.length > 0) {
      this.hasDisabledProductTypeEntries = this.draftOrder.entries.some((entry) => {
        const replacementCode = entry.replacementProduct?.code || (entry.product as any)?.replacementProduct?.code;
        const isDistChainBlocked =
          (entry as any)?.distChainMaterialStatus === 'Z5' || (entry.product as any)?.distChainMaterialStatus === 'Z5';
        return !!replacementCode && !isDistChainBlocked;
      });
    } else {
      this.hasDisabledProductTypeEntries = false;
    }
  }

  checkForBlockedDistChainEntries(): void {
    if (this.draftOrder && this.draftOrder.entries && this.draftOrder.entries.length > 0) {
      this.hasBlockedDistChainEntries = this.draftOrder.entries.some((entry) => {
        const entryStatus = (entry as any)?.distChainMaterialStatus;
        const productStatus = (entry.product as any)?.distChainMaterialStatus;
        return BLOCKED_DIST_CHAIN_STATUSES.includes(entryStatus) || BLOCKED_DIST_CHAIN_STATUSES.includes(productStatus);
      });
    } else {
      this.hasBlockedDistChainEntries = false;
    }
  }

  checkForZeroNetPriceEntries(): void {
    if (this.draftOrder && this.draftOrder.entries && this.draftOrder.entries.length > 0) {
      this.hasZeroNetPriceEntry = this.draftOrder.entries.some(
        (entry) => entry.knbrTotalPrice?.netPrice === 0
      );
    } else {
      this.hasZeroNetPriceEntry = false;
    }
  }

  updateCart() {
    // triggerItemUpdate() synchronously notifies every row (BehaviorSubject.next()),
    // and each row queues its changed quantity via queueEntryUpdate() -- so the queue
    // is fully populated by the time onSubmit() (called next) reads it and merges it
    // into the same header-update payload, sending everything in a single PATCH.
    this.knBrDraftOrderService.triggerItemUpdate();
    this.onSubmit();
    this.knBrDraftOrderService.setHasUnsavedItemChanges(false);
    // Clear line item errors on cart change
    this.knBrDraftOrderService.setLineItemErrors([]);
    this.isCustomerPOValid = true;
    this.integrationMessage = '';
    // Enable checkout button after cart update
    this.validateSapMessages();
    this.initialLoad = false;
  }

  detectChange() {
    this.cdr.detectChanges();
    this.knBrDraftOrderService.setHasUnsavedItemChanges(true);
  }

  // Replaces the old ngbTooltip anchored to the promo code field with a toast
  // card shown below it whenever the field has content. Typing again after a
  // manual dismiss brings it back, so the user can re-open it without having
  // to clear and retype the whole code.
  onPromoCodeInput(): void {
    this.isPromoCodeToastDismissed = false;
  }

  dismissPromoCodeToast(): void {
    this.isPromoCodeToastDismissed = true;
  }

  // Same toast pattern as the promo code field above, applied to the quote field.
  onQuoteInput(): void {
    this.isQuoteToastDismissed = false;
  }

  dismissQuoteToast(): void {
    this.isQuoteToastDismissed = true;
  }

  isWeekendDate = (date: NgbDateStruct): boolean => {
    if (!date) {
      return false;
    }
    const day = new Date(date.year, date.month - 1, date.day).getDay();
    return day === 0 || day === 6;
  };

  private weekendValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as NgbDateStruct;
    if (!value?.year || !value?.month || !value?.day) {
      return null;
    }
    return this.isWeekendDate(value) ? { weekend: true } : null;
  };

  private pastDateValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as NgbDateStruct;
    if (!value?.year || !value?.month || !value?.day) {
      return null;
    }
    const selectedDate = new Date(value.year, value.month - 1, value.day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selectedDate < today ? { pastDate: true } : null;
  };

  hasLineItemErrors(): boolean {
    const errors = this.knBrDraftOrderService.getLineItemErrors();

    if (errors && errors.length > 0) {
      this.lineItemErrorMessages = errors.map((e: any) => e.message);
      return true;
    }
    this.lineItemErrorMessages = [];
    return false;
  }

  updatePOValidationStatus(): void {
    if (this.draftOrder?.isCustomerPOValid == false) {
      this.isCustomerPOValid = false;
    } else {
      this.isCustomerPOValid = true;
    }
  }

    checkisECCAvailablele(): boolean{
    if(this.draftOrder?.isECCAvailable === false){
      this.isECCAvailable = false;
      this.integrationMessage = this.draftOrder?.integrationMessage ?? 'Real-time contract pricing is currently unavailable. Displayed prices are estimated List Prices; final totals will be calculated upon order processing.';
      return true;
    }else{
      this.isECCAvailable = true;
      this.integrationMessage = '';
      return false;
    }
  }

  validateSapMessages(): void {
    this.sapMessageErrors = {};
    this.hasSapErrors = false;

    if (this.draftOrder?.sapMessages && this.draftOrder.sapMessages.length > 0) {
      this.draftOrder.sapMessages.forEach((msg: any) => {
        if (msg.code === 'PROMO') {
          this.sapMessageErrors['promoCode'] = msg.message;
          this.hasSapErrors = true;
        } else if (msg.code === 'SALESDEAL') {
          this.sapMessageErrors['salesDeal'] = msg.message;
          this.hasSapErrors = true;
        } else if (msg.code === 'QUOTE') {
          this.sapMessageErrors['quote'] = msg.message;
          this.hasSapErrors = true;
        }
      });
    } else {
      this.hasSapErrors = false;
    }
  }

  onSubmit(isRedirect = false) {
    if (this.draftOrderEditForm?.valid) {
      const formValues = _.cloneDeep(this.draftOrderEditForm.getRawValue());
      if (this.draftOrderEditForm.controls.requestedDeliveryDate.value) {
        this.setRddOverride(this.draftOrderEditForm.controls.requestedDeliveryDate.value);
        formValues.requestedDeliveryDate = this.knBrDateHelper.formatDate(
          this.draftOrderEditForm.controls.requestedDeliveryDate.value
        );
      }
      if (this.isHeaderDiscountUpdate) {
        formValues.knbrHeaderDiscount = this.knBrHeaderDiscount ? this.knBrHeaderDiscount : '0';
      }
      formValues.isRedirect = isRedirect;
      if (!isRedirect) {
        // Merge any quantity changes queued by triggerItemUpdate() into this same
        // payload so the header fields and entry changes go out as ONE PATCH,
        // instead of a separate request per concern.
        const pendingEntries = this.knBrDraftOrderService.consumePendingEntryUpdates();
        if (pendingEntries.length) {
          formValues.entryList = pendingEntries;
        }
        this.submitOrder(formValues);
      } else {
        const draftOrderStatus = formValues.draftOrderStatus;
        if (draftOrderStatus === 'CART_SELLERAPPROVER_REJECTED' || draftOrderStatus === 'CART_BUYER_PENDING_APPROVAL') {
          this.openRejectQuotePopup(isRedirect, formValues);
        } else {
          this.updateCartStatus(formValues);
        }
      }
      // Allow the next active-cart emission to re-sync the form now that these edits are in flight.
      this.draftOrderEditForm.markAsPristine();
    } else {
      this.draftOrderEditForm.markAllAsTouched();
    }
  }

  updateCartStatus(formValues:any) {
    const payload = {
      headerNotes: formValues.headerComments,
      requestedDeliveryDate: formValues.requestedDeliveryDate
        ? this.knBrDateHelper.formatDate(formValues.requestedDeliveryDate)
        : null,
      jobName: formValues.jobName,
      shipComplete: formValues.shipComplete,
      cartStatus: formValues.draftOrderStatus,
      promoCode: formValues.promoCode,
      salesDeal: formValues.salesDeal,
      quote: formValues.quote,
      storeNumber: formValues.storeNumber,
      isRedirect: true,
    };
    this.knBrDraftOrderService.patch(payload);
  }

  setFieldVisibility(): void {

    let customerSalesArea = localStorage.getItem('kn-br-customer-sales-area');

    // Remove quotes if present
    if (customerSalesArea) {
      customerSalesArea = customerSalesArea.replace(/^"|"$/g, '');
    }
    const salesOrg = customerSalesArea ? customerSalesArea.split('_')[0].trim() : null;    

    this.showPromoCode = false;
    this.showQuoteNumber = false;
    this.showSalesDeal = false;
    this.showStoreNumber = false;

    if (salesOrg === '2700' || salesOrg === '1201') {
      this.showPromoCode = true;
    } else if (salesOrg === '1215') {
      this.showQuoteNumber = true;
    }

    if (salesOrg === '2700' ) {
      this.showStoreNumber = true;
    }
  }

  initForm() {
    this.draftOrderEditForm = this.fb.group({
      headerComments: [{ value: null, disabled: this.isDisabled() }],
      jobName: [{ value: null, disabled: this.isDisabled() }],
      name: [{ value: null, disabled: this.isDisabled() }, Validators.required],
      purchaseOrderNumber: [{ value: null, disabled: this.isDisabled() }, [
        Validators.required,
        Validators.maxLength(25),
        Validators.pattern(/^[^~`$&+,=?@|{}<>^()%![\]]*$/),
      ]],
      requestedDeliveryDate: [{ value: null, disabled: this.isDisabled() }, [Validators.required, this.weekendValidator, this.pastDateValidator]],
      shipComplete: [{ value: false, disabled: this.isDisabled() }],
      draftOrderStatus: null,
      promoCode: [{ value: null, disabled: this.isDisabled() }, [
        Validators.maxLength(40),
        Validators.pattern(/^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/)
      ]],
      salesDeal: [{ value: null, disabled: this.isDisabled() }, [
        Validators.maxLength(40),
        Validators.pattern(/^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/)
      ]],
      quote: [{ value: null, disabled: this.isDisabled() }, [
        Validators.maxLength(9),
        Validators.pattern(/^\d{0,9}$/)
      ]],
      orderReasonCode: [
        { value: null, disabled: this.isDisabled() },
        this.draftOrder?.orderType === 'ZFD' ? [Validators.required] : [],
      ],
      storeNumber: [{ value: null, disabled: this.isDisabled() }, [Validators.maxLength(20)]],
    });
  }

  patchForm(draftOrder: any) {
    super.patchForm(draftOrder);
    this.draftOrderEditForm.patchValue({
      promoCode: draftOrder.promoCode,
      salesDeal: draftOrder.salesDeal,
      quote: draftOrder.quote,
      orderReasonCode: draftOrder.costCenter,
      storeNumber: draftOrder.storeNumber,
    });
    // Re-applied on every single patchForm call, unconditionally -- covers the
    // immediate post-save reload, any number of subsequent cart re-emissions, and
    // any number of full page refreshes, all identically. There is no "consume
    // once" state to get out of sync: as long as this override exists for this
    // cart, it always wins over whatever super.patchForm() just parsed above.
    const override = this.getRddOverride();
    if (override) {
      this.draftOrderEditForm.patchValue({ requestedDeliveryDate: override });
      this.lastRequestedDeliveryDateParsed = override;
    }
    this.validateSapMessages();
    this.markPastDeliveryDateTouched();
    this.markInvalidSavedValueTouched('purchaseOrderNumber');
  }

  // Surface the pastDate error immediately for an already-saved past delivery date,
  // instead of waiting for the user to touch the field.
  private markPastDeliveryDateTouched(): void {
    const control = this.draftOrderEditForm.get('requestedDeliveryDate');
    if (control?.value && control?.errors?.pastDate) {
      control.markAsTouched();
    }
  }

  // Surface validation errors immediately for already-saved invalid data (e.g. special
  // characters in an existing Customer PO), instead of waiting for the user to touch the field.
  private markInvalidSavedValueTouched(controlName: string): void {
    const control = this.draftOrderEditForm.get(controlName);
    if (control?.value && control?.invalid) {
      control.markAsTouched();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
